module.exports = __webpack_public_path__ + "static/media/eStore-hero-securityBag2.3b0eaa02.png";